/**
 * @generated SignedSource<<23feaf83ae48c8070f8f6a5eb2195ced>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendEmailTestRemindUserBasisseminarInput = {
  clientMutationId?: string | null | undefined;
};
export type EmailTesterRemindUserToFinishBasisseminarNodeMutation$variables = {
  input: SendEmailTestRemindUserBasisseminarInput;
};
export type EmailTesterRemindUserToFinishBasisseminarNodeMutation$data = {
  readonly Admin: {
    readonly TesterEmail: {
      readonly EmailTestRemindUserBasisseminar: {
        readonly clientMutationId: string | null | undefined;
      } | null | undefined;
    };
  };
};
export type EmailTesterRemindUserToFinishBasisseminarNodeMutation = {
  response: EmailTesterRemindUserToFinishBasisseminarNodeMutation$data;
  variables: EmailTesterRemindUserToFinishBasisseminarNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TesterEmailAdminMutationSchema",
        "kind": "LinkedField",
        "name": "TesterEmail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SendEmailTestRemindUserBasisseminarPayload",
            "kind": "LinkedField",
            "name": "EmailTestRemindUserBasisseminar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTesterRemindUserToFinishBasisseminarNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTesterRemindUserToFinishBasisseminarNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "594d01d3e3a3812617f5beb3f88c5c31",
    "id": null,
    "metadata": {},
    "name": "EmailTesterRemindUserToFinishBasisseminarNodeMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTesterRemindUserToFinishBasisseminarNodeMutation(\n  $input: SendEmailTestRemindUserBasisseminarInput!\n) {\n  Admin {\n    TesterEmail {\n      EmailTestRemindUserBasisseminar(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00a052a881395e21d113fe85eac28494";

export default node;
